'use client';

import { useEffect } from 'react';

import { registerPendingApprovalHandler } from 'client-apis/helpers/pending-approval';
import { useModal } from 'store/modal-store';

/**
 * Bridges `callServerAction`'s pending-approval signal to the modal store. The fetch layer
 * lives below the modal layer and can't open modals directly, so it calls a registered
 * handler instead. Mounted once at app root so any gated mutation (HTTP 202) surfaces the
 * standard "awaiting approval" modal automatically.
 */
export default function PendingApprovalHandler() {
  const { openModal } = useModal();

  useEffect(
    () => registerPendingApprovalHandler((sensitiveActionId) => openModal('PendingApproval', { sensitiveActionId })),
    [openModal]
  );

  return null;
}
